module.exports = __webpack_public_path__ + "static/img/phone2.0bc6565a.png";